import Api from '../http.service';
/**
 * insert booking flight
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {Number} payload.data._id
 * @param {Object} payload.data.passengers
 * @param {Object} payload.data.searchData
 * @param {Object} payload.data.issuerContactInfo
 * @param {Object} payload.data.flights
 * @param {Object} payload.data.serviceType
 * @param {Object} payload.data.moneyUnit
 * @param {number} payload.data.commission
 * @param {Number} payload.data.totalPrice
 */
export const insert = (payload) =>
  Api.POST({ data: payload.data, url: `booking/insert` });

//get all booking data by id
/**@param {String} payload.id */
export const getBookingById = (id) => Api.GET({ url: `booking/id/${id}` });

/**
 * Assign Customer (onBehalf) to flightBooking
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.data.id
 */

export const assignCustomer = (payload) =>
  Api.POST({ url: 'booking/set_customer', data: payload.data });

/**
 * send  penalty_price for cancel process
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.data.id
 * @param {Number} payload.data.flightIndex
 */
export const penalty_price = (payload) =>
  Api.POST({
    data: payload.data,
    url: 'booking/penalty_price',
  });

/**
 * cancel reserve flight
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.data.id
 * @param {Number} payload.data.passengerIndex
 * @param {Number} payload.data.flightIndex
 * @param {Boolean} payload.data.creditPayment
 * @param {String} payload.data.cancelReason
 */
export const cancel = (payload) =>
  Api.PUT({ data: payload, data, url: 'booking/cancel' });

/**
 * archive flight
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.data.id
 */
export const archive = (payload) =>
  Api.POST({ url: 'booking/archive', data: payload.data });

/**
 *Get all reserve flight
 * @param {Object} payload
 * @param {Number} payload.pageNumber
 * @param {Number} payload.itemPerPage
 * @param {Object} payload.data
 * @param {String} payload.data.filter
 * @param {Object} payload.data.sort
 * @param {String} payload.data.sort.key
 * @param {String} payload.data.sort.value
 */

export const reservedByUser = (payload) =>
  Api.GET({
    url: `customer/flight/booking/reserve?page=${payload.pageNumber - 1}&size=${
      payload.itemPerPage
    }&where=${payload.data.filter}`,
  });

/**
 * get all  flight paid by user
 *
 * @param {Object} payload
 * @param {Number} payload.pageNumber
 * @param {Number} payload.itemPerPage
 * @param {Object} payload.data
 * @param {String} payload.data.filter
 * @param {Object} payload.data.sort
 * @param {String} payload.data.sort.key
 * @param {String} payload.data.sort.value
 */
export const paidByUser = (payload) =>
  Api.GET({
    url: `customer/flight/booking/purchase?page=${
      payload.pageNumber - 1
    }&size=${payload.itemPerPage}&where=${payload.data.filter}`,
  });
/**
 * get all history flight
 *
 * @param {Object} payload
 * @param {Number} payload.pageNumber
 * @param {Number} payload.itemPerPage
 * @param {Object} payload.data
 * @param {String} payload.data.filter
 * @param {Object} payload.data.sort
 * @param {String} payload.data.sort.key
 * @param {String} payload.data.sort.value
 */
export const historyByUser = (payload) =>
  Api.POST({
    url: `booking/history_by_user/${payload.pageNumber - 1}/${
      payload.itemPerPage
    }`,
    data: payload.data,
  });

/**
 * get all expired reserved flight
 * @param {Object} payload
 * @param {Number} payload.pageNumber
 * @param {Number} payload.itemPerPage
 * @param {Object} payload.data
 * @param {String} payload.data.filter
 * @param {Object} payload.data.sort
 * @param {String} payload.data.sort.key
 * @param {String} payload.data.sort.value
 */
export const expiredFlight = (payload) =>
  Api.GET({
    url: `customer/flight/booking/expire?page=${payload.pageNumber - 1}&size=${
      payload.itemPerPage
    }&where=${payload.data.filter}`,
  });

/**
 * update agency markup
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {string} payload.data.id
 * @param {Number} payload.data.markup
 * @param {String} payload.data.ticketType
 * @param {String} payload.data.customerId
 */
export const updateAgencyMarkup = ({
  pageNumber = 1,
  itemPerPage = 100,
  data,
}) =>
  Api.PUT({
    url: `booking/agency_markup`,
    data: data,
  });

/**
  //Track flight booking
  /**@param {String} trackingCode */
export const trackingOrder = (trackingCode) =>
  Api.GET({ url: `booking/track/${trackingCode}` });

// fetch list of customers in booking
/**
 *
 * @param {Object} payload
 * @param {Number} payload.itemPerPage
 * @param {Number} payload.pageNumber
 * @param {Object} payload.data
 * @param {String} payload.data.filter
 * @param {String} payload.data.filter.customerId
 * @param {String} paylaod.data.filter.status
 * @param {String} payload.data.filter.phrase
 * @param {String} payload.data.filter.startDate
 * @param {String} paylaod.data.filter.endDate
 * @param {String} payload.data.filter.departDate
 *
 */
export const fetchAllBookingCustomer = (payload) =>
  Api.GET({
    data: payload.data,
    url: `booking/all_customer_booking?page=${payload.pageNumber - 1}&size=${
      payload.itemPerPage
    }&where=${payload.data.filter}`,
  });
/**
 *
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.data._id
 * @param {String} payload.data.attachment
 */
export const RegistrationPaymentReceipt = (payload) =>
  Api.PATCH({
    data: payload.data,
    url: `flight/booking/attachment`,
  });

export const getCustomerBookingDetailsCount = () =>
  Api.GET({
    url: '/customer/flight/booking/count',
  });
export const getBookingDetailsCount = () =>
  Api.GET({
    url: '/flight/booking/count',
  });

/** Email Ticket
 *
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.data.id
 * @param {String} payload.data.language
 * @param {String} payload.data.email
 */
export const emailTicket = (payload) =>
  Api.POST({
    url: 'invoice/ticket/email',
    data: payload.data,
  });

/** Email Ticket
 *
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {Array}  payload.data.booking
 */
export const changeSalesRate = (payload) =>
  Api.PATCH({
    url: '/flight/booking/saleRates',
    data: payload.data,
  });
